export { default, default as VirtualHottieTag } from './VirtualHottieTag'
